
import { fetchApi } from "../utils";

const createMediasApi = file => {
  const data = new FormData();
  data.append("file", file);
  return fetchApi("medias", "POST", data, false);
};

export { createMediasApi };


// WEBPACK FOOTER //
// ./src/services/medias.js